import React from "react";

const footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="footer">
            <div className="copyright">
                © 2021-{currentYear} White Blocktech <span className="pc">白塊科技</span> All Rights Reserved
            </div>
        </footer>
    );
};
export default footer;
